import React, { useEffect } from 'react'
import WebFont from 'webfontloader';
import { Typography } from '@mui/material'

function P({ children, fontFamily, fontSize, textAlign, color, uppercase, fontWeight, style }) {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Nunito', 'Chilanka', 'Redressed']
      }
    });
  }, []);
  return (
    <Typography fontWeight={fontWeight || 400} sx={{ ...style, textTransform: uppercase ? 'uppercase' : 'unset' }} color={color || 'inherit'} textAlign={textAlign || 'unset'} typography="p" fontSize={fontSize || 18} fontFamily={fontFamily || 'Nunito'} style={{ wordWrap: 'break-word' }}>{children}</Typography>
  )
}

export default P